import { render } from "./Details.vue?vue&type=template&id=e8cec68e&scoped=true&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import "./Details.vue?vue&type=style&index=0&id=e8cec68e&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8cec68e"],['__file',"resources/js/Pages/Orchard/SymptomRecords/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8cec68e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8cec68e', __exports__)) {
    console.log('reload')
    api.reload('e8cec68e', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=e8cec68e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('e8cec68e', render)
  })

}


export default __exports__